import $ from "jquery";
import Router from "./router";
import common from "./routes/common";
import home from "./routes/home";
import team from "./routes/team";
import portfolio from "./routes/portfolio";
import solutions from "./routes/solutions";
import news from "./routes/news";
import careers from "./routes/careers";
import resources from "./routes/resources";
import assessmentTool from "./routes/assessmentTool";
import pageTemplateTemplateThoughtLeadership from "./routes/pageTemplateTemplateThoughtLeadership";
import pageTemplateTemplateNetrevealHomepage from "./routes/pageTemplateTemplateNetrevealHomepage";
import pageTemplateTemplateRoiCalculator from "./routes/pageTemplateTemplateRoiCalculator";
import pageTemplateTemplateSensaLanding from './routes/pageTemplateTemplateSensaLanding';

import "./plugins/slick.js";
import "./plugins/jquery.matchHeight.js";
import "simplebar"; // or "import SimpleBar from 'simplebar';" if you want to use it manually.
import "simplebar/dist/simplebar.css";

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
	/** All pages */
	common,
	/** Home page */
	home,
	/** Team page */
	team,
	/** Portfolio page */
	portfolio,
	/** Solutions page */
	solutions,
	/** News page */
	news,
	/** Careers page */
	careers,
	/** Resources page */
	resources,
	/** Thought leadership template */
	pageTemplateTemplateThoughtLeadership,
	/** NetReveal homepage redesign template */
	pageTemplateTemplateNetrevealHomepage,
	/** ROI Calculator template */
	pageTemplateTemplateRoiCalculator,
	/** sensa LP template */
	pageTemplateTemplateSensaLanding,
	pageTemplateTemplateNetrevealHomepage,
	/**  Assessment page **/
	assessmentTool,
});

/** Load Events */
$(document).ready(() => routes.loadEvents());

/*
 * This enables application of JS modules changes in HTML view.
 * Don't remove it!
 */

if (module.hot) {
	module.hot.accept();
}
